// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__XDcxn","add":"style_add__1CQGF","actions":"style_actions__n60AL","actions_btn":"style_actions_btn__yfeUY"};